<script setup>
/**
 * The worked example, and it is the REAL preview component, fed from the i18n tables: the
 * English table's EXAMPLE is the English menu and the Arabic table's is the Arabic one, so the
 * toggle on this card shows exactly what the two kinds of customer get. Four options on
 * purpose — the list form is the one owners have never seen.
 */
import { computed } from 'vue';

import MenuPreview from './MenuPreview.vue';
import { useWasloI18n, wasloT } from '../i18n.js';
import { toDraft } from '../helpers/menu-draft.js';

const { t, locale } = useWasloI18n();

const both = key => ({
  en: wasloT(null, `WASLO.MENUS.EXAMPLE.${key}`, 'en'),
  ar: wasloT(null, `WASLO.MENUS.EXAMPLE.${key}`, 'ar'),
});

const body = both('BODY');
const button = both('BUTTON');
const example = toDraft({
  title: '',
  whenToShow: '',
  enabled: true,
  bodyEn: body.en,
  bodyAr: body.ar,
  buttonEn: button.en,
  buttonAr: button.ar,
  options: ['OPTION_1', 'OPTION_2', 'OPTION_3', 'OPTION_4'].map(key => {
    const title = both(key);
    return { titleEn: title.en, titleAr: title.ar, taskId: null };
  }),
});

const initialLang = computed(() =>
  String(locale.value).startsWith('ar') ? 'ar' : 'en'
);
</script>

<template>
  <section
    class="flex flex-col gap-4 px-5 py-5 outline outline-1 rounded-xl outline-n-weak bg-n-solid-2"
    data-waslo-menu-example
  >
    <h2 class="mb-0 text-sm font-medium text-n-slate-12">
      {{ t('WASLO.MENUS.EXAMPLE.HEADING') }}
    </h2>
    <MenuPreview :draft="example" :initial-lang="initialLang" />
    <p class="mb-0 text-sm leading-6 text-n-slate-11">
      {{ t('WASLO.MENUS.EXAMPLE.NOTE') }}
    </p>
  </section>
</template>
